export default __webpack_public_path__ + "static/307-1f9474434e6cb3b2bd7b909711d49476.gif";